<template>
	<b-container>
		<template v-if="/^BUILDER 000/.test(item.courseId)">
			<b-row no-gutters>
				<b-col>
					<b-list-group-item class="m-0 p-0 text-light bg-dark" href="eLumin://provisioning">
						<b-row no-gutters class="w-100">
							<b-col class="m-0 p-0 w-75">
								<h5 class="ml-2 my-3 p-0 text-truncate">{{ item.course }}</h5>
							</b-col>
							<b-col cols="1" style="min-width: 5px;">
								<h5 class="my-3 p-0"><font-awesome-icon icon="play-circle" /></h5>
							</b-col>
						</b-row>
					</b-list-group-item>
				</b-col>
			</b-row>
		</template>
		<template v-else>
			<b-row no-gutters>
				<b-col>
					<b-list-group-item v-if="item.sandbox && item.sandbox.length" :to="'/enrollment/' + item.uuid" :id="item.uuid" :key="item.uuid" class="m-0 p-0" :class="(('enrollmentUUID' in $route.params && item.uuid === $route.params.enrollmentUUID) ? 'list-group-item-primary' : 'text-light bg-dark')">
						<b-row no-gutters class="w-100">
							<b-col class="m-0 p-0 w-75">
								<h5 class="ml-2 my-3 p-0 text-truncate">{{ item.courseId }}</h5>
							</b-col>
							<b-col cols="1" style="min-width: 5px;">
								<h5 class="my-3 p-0"><font-awesome-icon :icon="'caret-' + (('enrollmentUUID' in $route.params && item.uuid === $route.params.enrollmentUUID) ? 'down' : 'right')" /></h5>
							</b-col>
						</b-row>
						<b-tooltip :key="'tooltip.' + item.uuid" :target="item.uuid" triggers="hover" placement="right" boundary="viewport">{{ item.course }}</b-tooltip>
					</b-list-group-item>
					<b-list-group flush v-if="('enrollmentUUID' in $route.params && item.uuid === $route.params.enrollmentUUID)">
						<template v-for="s in item.sandbox">
							<b-list-group-item :to="'/enrollment/' + item.uuid + '/sandbox/' + s.uuid" :key="s.uuid" class="m-0 p-0 text-dark bg-light">
								<b-container class="m-0 p-0">
									<b-row no-gutters :class="('sandboxUUID' in $route.params && s.uuid === $route.params.sandboxUUID) ? 'text-blue' : ''">
										<b-col cols="1" style="min-width: 8px; max-width: 8px;" :class="('sandboxUUID' in $route.params && s.uuid === $route.params.sandboxUUID) ? 'bg-blue' : ''" />
										<b-col>
											<h6 class="ml-5 my-3 p-0 text-truncate">{{ s.label || s.name }}</h6>
										</b-col>
									</b-row>
								</b-container>
							</b-list-group-item>
						</template>
					</b-list-group>
				</b-col>
			</b-row>
		</template>
	</b-container>
</template>

<script>
	export default
	{
		props: [ 'item' ],
		name: 'nav-item',
		data() { return {}; }
	}
</script>

<style lang="scss" scoped>
	.bg-blue
	{
		background: $blue;
	}

	.text-blue
	{
		color: $blue;
	}
</style>
